export default function localeCheck( locale, defaultLocale ) {
  if ( locale === defaultLocale ) {
    return ''
  } else {
    return `/${locale}`
  }
}
